<template>
  <div>
    <div>
      <jd-tips>
        <p>
          1.非官方权益，商家自定义礼品卡，用户在获奖后，可在礼品卡详情页查看卡密信息及激活方法
        </p>
        <p>
          2.可配置在店铺营销活动中，提升店铺活动效果
        </p>
      </jd-tips>
      <div class="topTip">
        <div class="beans">
          <img
            style="width: 80px;"
            src="@/assets/images/integralCenter/icon_gift_card.png"
          />
        </div>
        <div class="beans">
          <span>待生效数量：</span>
          <span style="color: #2768ff">{{ waitNum }}</span>
        </div>
        <div class="beans">
          <span>已生效剩余数量：</span>
          <span style="color: #2768ff">{{ goingNum }}</span>
        </div>
      </div>
      <input-form
        ref="inputForm"
        style="margin: 40px 20px"
        :inputData="inputData"
        @toParentVal="search"
        :btnPosition1="true"
      ></input-form>
    </div>
    <el-button
      type="primary"
      style="margin: 0 0 40px 30px"
      v-zoom="{ from: '忠诚度管理-资产项管理', name: '创建计划' }"
      @click="createPopup"
      ><img
        src="@/assets/images/member/new_establish.png"
        style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin-right: 3px;
          "
      />创建计划</el-button
    >
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      style="width: 95%;margin: 0 auto"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <template slot="empty">
        <div>
          <img
            src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
          />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-table-column label="礼品卡名称" width="180">
        <template slot-scope="scope">
          <div>{{ scope.row.planName }}</div>
          <div class="copy">
            <span>id：{{ scope.row.id }}</span>
            <img
              src="@/assets/images/integralCenter/copy.svg"
              alt
              v-clipboard:copy="scope.row.id"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              style="width: 16px;height:16px;cursor: pointer;"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="礼品卡图片" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.planImg"
            style="width: 100px; height: 100px"
            :src="scope.row.planImg"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="礼品卡说明" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.description"
            placement="right-start"
            v-if="scope.row.description && scope.row.description.length > 20"
          >
            <div>{{ descLimit(scope.row.description) }}</div>
          </el-tooltip>
          <div v-else>{{ scope.row.description }}</div>
        </template>
      </el-table-column>
      <el-table-column label="激活方式" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.activateType === 0">卡号+密码</div>
          <div v-else>仅卡号</div>
        </template>
      </el-table-column>
      <el-table-column prop="quantityTotal" label="发行量" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.quantityTotal >= 0">
            {{ scope.row.quantityTotal }}
          </span>
          <span v-else>-</span>
        </template></el-table-column
      >
      <el-table-column prop="grantNum" label="已发放" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.grantNum >= 0">
            {{ scope.row.grantNum }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="剩余" prop="quantityBalance" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.quantityBalance >= 0">
            {{ scope.row.quantityBalance }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150">
        <template slot-scope="scope">
          <span :class="getStatusIcon(scope.row.status)">
            {{ scope.row.status | statusStr }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="已关联活动" width="100">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.relActivityCnt"
            type="text"
            @click="getActivity(scope.row.id)"
            style="width: auto;margin: 0;padding: 0 !important;"
            >{{ scope.row.relActivityCnt }}</el-button
          >
          <span v-else>{{ scope.row.relActivityCnt || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="计划时间" width="200">
        <template slot-scope="scope">
          <span>起：{{ scope.row.startTime }}</span
          ><br />
          <span>止：{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createTime"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            type="text"
            :isZoom="true"
            v-zoom="{
              from: '忠诚度管理-资产项管理-礼品卡',
              name: '修改',
            }"
            class="operation"
            style="width: 40px"
            @click="handleEdit(scope.row)"
            :disabled="scope.row.status == 3"
            >修改</el-button
          >
          <el-button
            type="text"
            v-zoom="{
              from: '忠诚度管理-资产项管理-礼品卡',
              name: '终止',
            }"
            class="operation"
            style="width: 40px;"
            :disabled="scope.row.status == 3"
            @click="marketStop(scope.row)"
            >终止</el-button
          >
          <el-button
            type="text"
            v-zoom="{
              from: '忠诚度管理-资产项管理-礼品卡',
              name: '数据明细',
            }"
            class="operation"
            style="width: 40px;"
            @click="marketNowDetail(scope.row)"
            >数据明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="formData.current"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="formData.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    ></el-pagination>
    <!-- 创建计划 -->
    <el-dialog
      title="创建计划"
      :visible.sync="dialogFormVisible"
      destroy-on-close
      width="730px"
      @close="handleClosePlan"
    >
      <jd-tips color="blue" margin="0 0 20px 0">
        <p>
          1.非官方权益，商家自定义礼品卡，用户在获奖后，可在礼品卡详情页查看卡密信息及激活方法
        </p>
        <p>
          2.可配置在店铺营销活动中，提升店铺活动效果
        </p>
      </jd-tips>
      <el-form
        :model="formSet"
        :rules="rules"
        ref="formSet"
        label-width="124px"
        class="new-input-box"
      >
        <el-form-item label="计划名称" prop="planName">
          <el-input
            v-model="formSet.planName"
            maxlength="12"
            show-word-limit
            placeholder="请输入"
            style="width: 400px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="计划时间" prop="startTime">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="formSet.startTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time1"
              :clearable="false"
              :picker-options="startTimeOption"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="formSet.endTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time2"
              :clearable="false"
              :picker-options="endTimeOption"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
        </el-form-item>
        <el-form-item label="激活方式" prop="activateType">
          <el-radio-group v-model="formSet.activateType">
            <el-radio :label="0">卡号+密码</el-radio>
            <el-radio :label="1">仅卡号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入激活码" prop="quantityTotal" required>
          <div class="import">
            <div>
              <el-upload
                class="upload-demo"
                action="#"
                :file-list="fileList"
                :on-remove="handleRemoveFile"
                :http-request="httpUpload"
                accept=".csv, .txt, .xls, .xlsx"
              >
                <el-button size="small" type="primary" v-loading="uploadLoading"
                  >选择文件</el-button
                >
              </el-upload>
            </div>
            <div class="import-right">
              <el-button
                style="margin-left: 8px;"
                type="text"
                @click="downLoadTemplate"
                >下载导入模板</el-button
              >
            </div>
          </div>
          <div class="import-tip" v-if="errorTip">
            {{ errorTip }}
          </div>
          <div class="import-text">
            <p>请下载模板后填写模板内容进行导入</p>
            <p>导入处理规则：</p>
            <p>1. 仅处理excel中第一个sheet页；</p>
            <p>2. 最多支持导入10万条数据；</p>
            <p>3. 选择卡号+密码时，卡号及密码均必填，若填写错误则无法导入</p>
          </div>
        </el-form-item>
        <el-form-item label="计划数量">
          <span v-if="formSet.quantityTotal"
            >{{ formSet.quantityTotal }}张</span
          >
          <span v-else>--张</span>
        </el-form-item>
        <el-form-item label="礼品卡图片" required>
          <div class="upload">
            <el-upload
              :class="isHideUpload ? 'hide' : ''"
              action="/jd-hd-web/image/upload"
              list-type="picture-card"
              :file-list="imgList"
              :before-upload="beforeUploadPic"
              :on-success="handleUploadSuccess"
              :on-remove="handleRemovePic"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <div class="planImg">
              <div class="planImg-tip">
                <p>图片大小：不超过1M，支持JPG、PNG</p>
                <p>用于移动端礼品卡详情页展示</p>
              </div>
              <el-button
                type="text"
                style="margin-left: -35px"
                @click="resetUrl"
                >重置</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="礼品卡描述" prop="description">
          <el-input
            type="textarea"
            v-model="formSet.description"
            maxlength="255"
            show-word-limit
            placeholder="请输入礼品卡说明、礼品卡的兑换激活方式，引导用户进行卡片的激活"
            style="width: 400px;"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClosePlan" width="80px">取 消</el-button>
        <el-button
          type="primary"
          style="margin-left: 8px"
          width="80px"
          @click="dialogFormSet('formSet')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改结束时间 -->
    <!-- <el-dialog title="修改结束时间" :visible.sync="dialogRevise" width="375px">
      结束时间
      <el-date-picker
        prefix-icon="no_icon"
        v-model="formEnd.planEndTime"
        type="datetime"
        :placeholder="'选择日期时间'"
        size="small"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 180px; font-size: 12px; margin-right: 12px"
        class="time1"
        :picker-options="endPlanOption"
        :clearable="false"
      ></el-date-picker>
      <template #footer>
        <el-button type="primary" @click="modifyConfirmation">确定</el-button>
      </template>
    </el-dialog> -->
    <!-- 修改 -->
    <el-dialog
      title="修改"
      :visible.sync="dialogRevise"
      width="730px"
      class="new-input-box"
    >
      <jd-tips
        color="gley"
        v-if="formEnd.planEndTime"
        style="margin: 0 0 16px 0"
      >
        <div>
          <p>
            当前礼品卡已关联活动，活动最晚结束时间为{{
              formEnd.planEndTime
            }}，礼品卡计划结束时间需晚于这一时间
          </p>
        </div>
      </jd-tips>
      <el-form
        :model="modifyForm"
        :rules="modifyRules"
        label-width="124px"
        class="new-input-box"
      >
        <el-form-item label="计划时间" prop="startTime">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="modifyForm.planStartTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time1"
              :clearable="false"
              :picker-options="modifyStartTimeOption"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="modifyForm.planEndTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time2"
              :clearable="false"
              :picker-options="modifyEndTimeOption"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearModifyTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
        </el-form-item>
        <el-form-item label="礼品卡图片" required>
          <div class="upload">
            <el-upload
              :class="isHideUpload ? 'hide' : ''"
              ref="upload"
              action="/jd-hd-web/image/upload"
              list-type="picture-card"
              :file-list="modifyForm.planImg"
              :before-upload="beforeUploadPic"
              :on-success="modifyHandleUploadSuccess"
              :on-remove="modifyHandleRemovePic"
            >
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <div class="planImg">
              <div class="planImg-tip">
                <p>图片大小：不超过1M，支持JPG、PNG</p>
                <p>用于移动端礼品卡详情页展示</p>
              </div>
              <el-button
                type="text"
                style="margin-left: -35px"
                @click="modifyResetUrl"
              >
                重置
              </el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="礼品卡描述" prop="description">
          <el-input
            type="textarea"
            v-model="modifyForm.description"
            maxlength="255"
            show-word-limit
            placeholder="请输入礼品卡说明、礼品卡的兑换激活方式，引导用户进行卡片的激活"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRevise = false" width="80px">取 消</el-button>
        <el-button
          type="primary"
          style="margin-left: 8px"
          width="80px"
          @click="modifyConfirmation"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 数据明细 -->
    <el-dialog title="数据明细" :visible.sync="detailDialog" width="1200px">
      <el-tabs
        v-model="detailDialogActiveName"
        type="card"
        @tab-click="detailDialogHandleClick"
      >
        <el-tab-pane label="已发放" name="1">
          <input-form
            ref="inputRef"
            :inputData="inputDataDetail"
            :btnPosition1="true"
            @toParentVal="searchGiftCardDetail"
          ></input-form>
          <el-table
            v-loading="tableDetailLoading"
            :data="giftCardList"
            style="width: 100%;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            height="400"
          >
            <el-table-column prop="pin" label="用户pin（加密）" width="150">
              <template slot-scope="scope">
                {{ getChangePin(scope.row.pin) }}
              </template>
            </el-table-column>
            <el-table-column
              property="memberNick"
              label="用户昵称"
            ></el-table-column>
            <el-table-column
              property="prizeName"
              label="礼品卡名称"
            ></el-table-column>
            <el-table-column property="cardKey">
              <template #header>
                <span>卡号</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="已发放时才确认卡号卡密的发送，待发放时不会显示"
                  placement="top"
                >
                  <i style="color: #ccc" class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.cardKey">{{ scope.row.cardKey }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              property="prizeNum"
              label="发送数量"
            ></el-table-column>
            <el-table-column
              property="activityName"
              label="活动名称"
            ></el-table-column>
            <el-table-column property="activitySubType" label="活动类型">
              <template slot-scope="scope">
                <span v-if="scope.row.activitySubType == 1"> 签到赢好礼 </span>
                <span v-if="scope.row.activitySubType == 2">
                  浏览礼品有礼
                </span>
                <span v-if="scope.row.activitySubType == 3"> 每日限时抢 </span>
                <span v-if="scope.row.activitySubType == 4">
                  关注店铺有礼
                </span>
                <span v-if="scope.row.activitySubType == 5">
                  邀请开卡有礼
                </span>
                <span v-if="scope.row.activitySubType == 6">
                  邀请关注有礼
                </span>
                <span v-if="scope.row.activitySubType == 7">
                  完善信息有礼
                </span>
                <span v-if="scope.row.activitySubType == 8"> 幸运抽奖 </span>
                <span v-if="scope.row.activitySubType == 9">
                  积分兑换实物
                </span>
                <span v-if="scope.row.activitySubType == 10">
                  积分兑换优惠券
                </span>
                <span v-if="scope.row.activitySubType == 11"> 新人优惠券 </span>
                <span v-if="scope.row.activitySubType == 12"> 会员优惠券 </span>
                <span v-if="scope.row.activitySubType == 13">开卡礼包</span>
                <span v-if="scope.row.activitySubType == 14">店铺礼包</span>
                <span v-if="scope.row.activitySubType == 15"
                  >店铺礼包（千人千面）</span
                >
                <span v-if="scope.row.activitySubType == 16">下单有礼</span>
                <span v-if="scope.row.activitySubType == 17">首单专享礼</span>
                <span v-if="scope.row.activitySubType == 18">复购有礼</span>
                <span v-if="scope.row.activitySubType == 19">下单抽奖</span>
                <span v-if="scope.row.activitySubType == 20">评价有礼</span>
                <span v-if="scope.row.activitySubType == 21">裂变神券</span>
                <span v-if="scope.row.activitySubType == 22">天降红包雨</span>
                <span v-if="scope.row.activitySubType == 23">欢乐娃娃机</span>
                <span v-if="scope.row.activitySubType == 24">大家来找茬</span>
                <span v-if="scope.row.activitySubType == 25">智能活动海报</span>
                <span v-if="scope.row.activitySubType == 26">刮刮乐</span>
                <span v-if="scope.row.activitySubType == 27">预售有礼</span>
                <span v-if="scope.row.activitySubType == 28">预售抽奖</span>
                <span v-if="scope.row.activitySubType == 31">超级裂变券</span>
                <span v-if="scope.row.activitySubType == 32">会员卡片</span>
                <span v-if="scope.row.activitySubType == 33">0元试用</span>
                <span v-if="scope.row.activitySubType == 34">加购有礼</span>
                <span v-if="scope.row.activitySubType == 36">下单冲榜</span>
                <span v-if="scope.row.activitySubType == 39">生日有礼</span>
              </template>
            </el-table-column>
            <el-table-column
              property="joinTime"
              label="发放时间"
            ></el-table-column>
            <el-table-column property="sendStatus" label="发放结果">
              <template slot-scope="scope">
                <span v-if="scope.row.sendStatus == 0">发放成功</span>
                <span v-if="scope.row.sendStatus == 1">发放失败</span>
                <span v-if="scope.row.sendStatus == 2">待发放</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleDetailSizeChange"
            @current-change="handleDetailCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalDetail"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="待发放" name="2">
          <!-- v-if="permissions" -->
          <div style="display: flex; justify-content: flex-end">
            <el-button @click="exportTheData">导出</el-button>
          </div>
          <div class="new-table-box" style="margin-top: 20px">
            <el-table
              v-loading="NotSendGiftData.loading"
              :data="NotSendGiftData.list"
              style="width: 100%"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
              height="400"
            >
              <el-table-column
                property="prizeName"
                label="礼品卡名称"
              ></el-table-column>
              <el-table-column
                property="cardKey"
                label="卡号"
              ></el-table-column>
              <el-table-column
                property="cardSecret"
                label="卡密"
              ></el-table-column>
            </el-table>
          </div>
          <div
            class="new-pagination-page"
            style="margin-top: 20px; text-align: right"
          >
            <el-pagination
              background
              @size-change="handleDetailSizeChange"
              @current-change="handleDetailCurrentChange"
              :current-page="formList.current"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="formList.size"
              layout="total, sizes, prev, pager, next, jumper"
              class="pagination"
              :total="NotSendGiftData.total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 关联活动弹窗 -->
    <el-dialog
      :title="activityDialog.title"
      :visible.sync="activityDialog.isShow"
      width="700px"
    >
      <jd-tips
        v-if="activityDialog.tipShow"
        color="gley"
        style="margin:0 0 20px 0"
      >
        <p>当前礼品卡关联未开始/进行中活动，请先手动结束活动再修改</p>
      </jd-tips>
      <el-form inline>
        <el-row>
          <el-col :span="18">
            <el-form-item label="礼品卡名称：">
              <span>{{ activityData.planName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态：">
              <span>{{
                activityData.status == 1
                  ? "未开始"
                  : activityData.status == 2
                  ? "进行中"
                  : "已结束"
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="计划时间：">
              <span>{{
                activityData.startTime + "至" + activityData.endTime
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :header-cell-style="{ background: '#fafafa' }"
        v-loading="activityDialog.tableLoading"
        height="250"
        :data="activityData.relActivity"
      >
        <el-table-column label="关联活动" prop="activityName"></el-table-column>
        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime + "至" + scope.row.endTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="!scope.row.status">未知</span>
            <span v-if="scope.row.status == 1">未开始</span>
            <span v-if="scope.row.status == 2">进行中</span>
            <span v-if="scope.row.status == 3">已结束</span>
            <span v-if="scope.row.status == 4">已下架</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" v-if="activityDialog.showBtn">
        <el-button
          type="primary"
          style="margin-right: 8px;width: auto;"
          @click="closeRelActivity"
          >一键结束全部活动</el-button
        >
        <el-button type="blue" @click="activityDialog.isShow = false"
          >我知道了</el-button
        >
      </div>
    </el-dialog>
    <!-- 导出身份验证 -->
    <exportVerify
      :visible="isShowVerify"
      @close="isShowVerify = false"
      @submit="submitExport"
    />
  </div>
</template>
<script>
import inputForm from "@/components/inputForm";
import jdTips from "@/components/common/jdTips.vue";
import { mapState } from "vuex";
import { querySellerSetting } from "@/api/userInform";
import exportVerify from "@/components/export-verify.vue";
import {
  getGiftCardCount,
  getGiftCardPage,
  addGiftCard,
  importCardKey,
  updateGiftCard,
  stopGiftCard,
  getGiftCardDetailPage,
  getRelActivity,
  closeRelActivity,
  getNotSendGiftCardDetailPage,
  exportNotSendDetail,
} from "@/api/integralCenter/prizeCenter.js";
export default {
  components: {
    inputForm,
    jdTips,
    exportVerify,
  },
  filters: {
    statusStr(status) {
      return {
        0: "未知",
        1: "未开始",
        2: "进行中",
        3: "已结束",
        null: "null",
      }[status];
    },
    showNumber(num) {
      if (num > 0) {
        return num;
      } else {
        return 0;
      }
    },
  },
  props: {},
  data() {
    const checkTime = (rule, value, callback) => {
      if (!this.formSet.startTime || !this.formSet.endTime) {
        callback(new Error("请选择计划时间"));
      } else {
        callback();
      }
    };
    const modifyCheckTime = (rule, value, callback) => {
      if (!this.modifyForm.planStartTime || !this.modifyForm.planEndTime) {
        callback(new Error("请选择计划时间"));
      } else {
        callback();
      }
    };
    return {
      uploadLoading: false,
      tableDetailLoading: false,
      imgList: [],
      isHideUpload: true,
      errorTip: "",
      waitNum: 0,
      goingNum: 0,
      inputData: [
        {
          name: "礼品卡名称:",
          val: "planName",
          placeholder: "请输入",
        },
        {
          name: "计划日期:",
          myDate: true,
          val: ["planStartTime", "planEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部状态", id: "" },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      formData: {
        current: 1,
        size: 10,
        status: 0,
        planName: "",
        planStartTime: "",
        planEndTime: "",
      },
      total: 0,
      dialogFormVisible: false,
      tableLoading: false,
      tableData: [],
      dialogRevise: false,
      detailDialog: false,
      formEnd: {
        id: "",
        planEndTime: "",
      },
      formDetail: {},
      formList: {
        current: 1,
        size: 10,
        pin: "",
        grantStartTime: "",
        grantEndTime: "",
        activityName: "",
      },
      formSet: {
        planName: "",
        startTime: "",
        endTime: "",
        activateType: 0,
        planImg:
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/gift_card.png",
        description: "",
        quantityTotal: "",
        batchId: "",
      },
      inputDataDetail: [
        {
          name: "用户pin",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "发放时间",
          myDate: true,
          val: ["grantStartTime", "grantEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "活动名称",
          val: "activityName",
          placeholder: "请输入",
        },
      ],
      fileList: [],
      giftCardList: [],
      totalDetail: 0,
      rules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
          { min: 1, max: 12, message: "不能超过 12 个字符", trigger: "blur" },
        ],
        startTime: { required: true, validator: checkTime, trigger: "change" },
        quantityTotal: [
          { required: true, message: "请导入激活码", trigger: "change" },
        ],
        description: [
          { required: true, message: "请填写礼品卡描述", trigger: "blur" },
        ],
        activateType: [
          { required: true, message: "请选择激活方式", trigger: "change" },
        ],
      },
      modifyRules: {
        startTime: {
          required: true,
          validator: modifyCheckTime,
          trigger: "change",
        },
        description: [
          { required: true, message: "请填写礼品卡描述", trigger: "blur" },
        ],
      },
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.formSet.endTime;
          let time = date.getTime();
          return (
            time < new Date().getTime() - 24 * 60 * 60 * 1000 ||
            time > new Date(endTime).getTime()
          );
        },
      },
      modifyStartTimeOption: {
        disabledDate: (date) => {
          let endTime = this.modifyForm.planEndTime;
          let time = date.getTime();
          return (
            time < new Date().getTime() - 24 * 60 * 60 * 1000 ||
            time > new Date(endTime).getTime()
          );
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.formSet.startTime;
          let time = date.getTime();
          return time < new Date(startTime).getTime();
        },
      },
      modifyEndTimeOption: {
        disabledDate: (date) => {
          let startTime = this.modifyForm.planStartTime;
          let time = date.getTime();
          return time < new Date(startTime).getTime();
        },
        selectableRange: "00:00:00 - 23:59:59",
      },
      endPlanOption: {
        disabledDate: (date) => {
          let endTime = this.enPlanTime;
          let time = date.getTime();
          return time < new Date(endTime).getTime();
        },
        selectableRange: "00:00:00 - 23:59:59",
      },
      formStop: {},
      activityDialog: {
        isShow: false,
        showBtn: false,
        title: "温馨提示",
        tableLoading: false,
        tipShow: false,
      },
      activityData: {},
      modifyForm: {
        id: "",
        planStartTime: "",
        planEndTime: "",
        planImg: [],
        description: "",
        venderId: "",
      },
      detailDialogActiveName: "1",
      NotSendGiftData: {
        total: 0,
        loading: false,
        list: [],
      },
      isShowVerify: false,
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
    descLimit() {
      return (desc) => {
        if (desc) {
          return desc.length > 20 ? desc.substring(0, 20) + "..." : desc;
        } else {
          return "";
        }
      };
    },
    getStatusIcon() {
      return (status) => {
        let className = "state ";
        switch (status) {
          case 0:
            className = "";
            break;
          case 1:
            className += "y1";
            break;
          case 2:
            className += "y2";
            break;
          case 3:
            className += "y3";
            break;
        }
        return className;
      };
    },
    getChangePin() {
      return (pin) => {
        if (pin) {
          return pin.charAt(0) + "***" + pin.charAt(pin.length - 1);
        } else {
          return "-";
        }
      };
    },
    permissions() {
      console.log(this.$store.getters.loginUserInfo.permissions);

      return (
        this.$store.getters.loginUserInfo.permissions.indexOf(
          "platform:giftCard:export"
        ) != "-1"
      );
    },
  },
  watch: {
    "formEnd.planEndTime"(planEndTime) {
      const selectTime = new Date(planEndTime).getTime();
      const enPlanTime = new Date(this.enPlanTime);
      const currentTime = enPlanTime.getTime();
      if (selectTime <= currentTime) {
        const hours = String(enPlanTime.getHours()).padStart(2, "0");
        const minutes = String(enPlanTime.getMinutes()).padStart(2, "0");
        const seconds = String(enPlanTime.getSeconds()).padStart(2, "0");
        this.endPlanOption.selectableRange = `${hours}:${minutes}:${seconds} - 23:59:59`;
      } else {
        this.endPlanOption.selectableRange = `00:00:00 - 23:59:59`;
      }
    },
  },
  mounted() {
    this.getGiftCardCounts();
    this.$nextTick(() => {
      this.$refs.inputForm.formSearch();
    });
  },
  methods: {
    async exportTheData() {
      const res = await querySellerSetting();
      if (res.data.isOpenDownloadRemind === 1) {
        // 不需要验证码
        this.submitExport({
          id: this.formList.id,
        });
      } else {
        // 需要验证码
        this.isShowVerify = true;
      }
    },
    submitExport(obj) {
      this.get_export({
        id: this.formList.id,
        code: obj.code,
      });
    },
    async get_export(data) {
      const res = await exportNotSendDetail(data);
      console.log(res);
      if (res.code == 1) {
        this.createAndDownload(res);
      } else {
        this.$message.warning(res.message);
      }
    },
    // 创建a标签下载
    createAndDownload(res) {
      const href = URL.createObjectURL(res.blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.setAttribute("href", href);
      let Time = new Date().toLocaleString();
      a.download = '待发放礼品卡记录 ' + Time + ' .xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(href);
    },
    async closeRelActivity() {
      const res = await closeRelActivity(this.formStop.id);
      console.log(res);

      if (res.code) {
        this.$message.success(res.message);
        this.getRelActivity(this.formStop.id);
      } else {
        this.$message.error(res.message || "一键结束活动失败");
      }
    },
    getActivity(planId) {
      this.activityDialog.title = "关联活动";
      this.activityDialog.tipShow = false;
      this.activityDialog.showBtn = false;
      this.getRelActivity(planId);
    },
    async getRelActivity(planId) {
      this.activityDialog.tableLoading = true;
      const res = await getRelActivity(planId);
      this.activityDialog.tableLoading = false;
      this.activityData = res.data;
      this.activityDialog.isShow = true;
    },
    handleClosePlan() {
      this.formSet.endTime = "";
      this.$refs.formSet.resetFields();
      this.dialogFormVisible = false;
    },
    async getGiftCardCounts() {
      const res = await getGiftCardCount();
      if (res.code == 1) {
        this.waitNum = res.data.waitNum;
        this.goingNum = res.data.goingNum;
      } else {
        this.$message.error(res.message);
      }
    },
    async getList() {
      try {
        this.tableLoading = true;
        const res = await getGiftCardPage(this.formData);
        if (res.code == 1) {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = Number(res.data.total);
        }
      } catch (error) {
        this.tableLoading = false;
      }
    },
    search(val) {
      this.formData.current = 1;
      this.formData.size = 10;
      this.formData.planName = val.planName;
      this.formData.planStartTime = val.planStartTime;
      this.formData.planEndTime = val.planEndTime;
      this.formData.status = val.status;
      this.getList();
    },
    //创建礼品卡弹窗
    createPopup() {
      this.isHideUpload = true;
      this.formSet.planImg =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/gift_card.png";
      this.imgList = [
        {
          url: this.formSet.planImg,
          name: this.formSet.planName,
        },
      ];
      this.dialogFormVisible = true;
    },
    handleCreateByMe() {
      this.formData.current = 1;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    handleEdit(row) {
      // this.formEnd.id = row.id;
      // this.formEnd.planEndTime = row.endTime;
      // this.enPlanTime = row.endTime;
      // this.dialogRevise = true;
      let data = JSON.parse(JSON.stringify(row));
      this.modifyForm.id = data.id;
      this.modifyForm.planStartTime = data.startTime;
      this.modifyForm.planEndTime = data.endTime;
      this.formEnd.planEndTime = data.relActivityMaxEndTime || 0;
      this.modifyForm.planImg = [
        {
          url: data.planImg,
          name: "",
        },
      ];
      this.modifyForm.description = data.description;
      this.modifyForm.venderId = data.venderId;
      this.dialogRevise = true;
    },
    async modifyConfirmation() {
      // const res = await updateGiftCard(this.formEnd);
      // if (res.code == 1) {
      //   this.dialogRevise = false;
      //   this.$message.success("操作成功");
      //   this.getList();
      // } else {
      //   this.$message.error(res.message);
      // }
      let putData = JSON.parse(JSON.stringify(this.modifyForm));
      if (!putData.planImg.length) {
        this.$message.error("礼品卡图片不能为空");
        return;
      }
      putData.planImg = putData.planImg[0].url;
      const res = await updateGiftCard(putData);
      if (res.code == 1) {
        this.dialogRevise = false;
        this.$message.success("操作成功");
        this.getList();
      } else {
        this.$message.error(res.message);
      }
    },
    marketStop(row) {
      if (row.status != 3) {
        // return this.$message.warning(
        //   "已有未开始/进行中的活动正在使用，请勿停止计划"
        // );
        this.formStop = row;
        this.activityDialog.title = "温馨提示";
        this.activityDialog.tipShow = true;
        this.activityDialog.showBtn = true;
        this.getRelActivity(row.id);
        return;
      }
      this.$confirm("是否终止计划?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          const res = await stopGiftCard({ id: row.id });
          if (res.code == 1) {
            this.outerVisible = false;
            this.$message.success("操作成功");
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消...",
          });
        });
    },
    async getGiftCardDetail() {
      this.tableDetailLoading = true;
      try {
        const res = await getGiftCardDetailPage(this.formList);
        if (res.code == 1) {
          this.tableDetailLoading = false;
          this.giftCardList = res.data.records;
          this.totalDetail = Number(res.data.total);
        } else {
          this.tableDetailLoading = false;
        }
      } catch (error) {
        this.tableDetailLoading = false;
      }
    },
    marketNowDetail(row) {
      this.formList.id = row.id;
      this.detailDialogActiveName = "1";
      this.detailDialog = true;
      this.formList.current = 1;
      this.formList.size = 10;
      this.$nextTick(() => {
        this.$refs.inputRef.formSearch();
      });
    },
    detailDialogHandleClick(val) {
      let index = val.index;
      this.formList.current = 1;
      this.formList.size = 10;
      if (!index) {
        this.$nextTick(() => {
          this.getGiftCardDetail();
        });
      } else {
        this.$nextTick(() => {
          this.getNotSendGiftCardDetailPage();
        });
      }
    },
    async getNotSendGiftCardDetailPage() {
      this.NotSendGiftData.loading = true;
      try {
        const res = await getNotSendGiftCardDetailPage({
          id: this.formList.id,
          current: this.formList.current,
          size: this.formList.size,
        });
        if (res.code == 1) {
          this.NotSendGiftData.list = res.data.records;
          this.NotSendGiftData.total = Number(res.data.total);
        }
        this.NotSendGiftData.loading = false;
      } catch (error) {
        this.NotSendGiftData.loading = false;
      }
    },
    searchGiftCardDetail(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.formList.pin = val.pin;
      this.formList.grantStartTime = val.grantStartTime;
      this.formList.grantEndTime = val.grantEndTime;
      this.formList.activityName = val.activityName;
      this.getGiftCardDetail();
    },
    //分页变化事件
    handleSizeChange(val) {
      this.formData.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formData.current = val;
      this.getList();
    },
    //分页变化事件
    handleDetailSizeChange(val) {
      this.formList.size = val;
      if (this.detailDialogActiveName == "1") {
        this.getGiftCardDetail();
      } else {
        this.getNotSendGiftCardDetailPage();
      }
    },
    handleDetailCurrentChange(val) {
      this.formList.current = val;
      if (this.detailDialogActiveName == "1") {
        this.getGiftCardDetail();
      } else {
        this.getNotSendGiftCardDetailPage();
      }
    },
    //时间清空
    clearTimeSendTime() {
      this.formSet.startTime = "";
      this.formSet.endTime = "";
    },
    //时间清空
    clearModifyTimeSendTime() {
      this.modifyForm.planStartTime = "";
      this.modifyForm.planEndTime = "";
    },
    downLoadTemplate() {
      window.open(
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E7%A4%BC%E5%93%81%E5%8D%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx",
        "_blank"
      );
    },
    beforeUploadPic(file) {
      // 获取当前剩余可上传文件大小
      let surplusSize = 1024 * 1024 * 1;
      // 控制单个文件的上传大小  字节
      if (file.size > surplusSize) {
        this.$message.info("文件上传失败，所有内容大小不超过1M");
        return false;
      }
      let types = [".png", ".jpg"];
      let type = file.name.substring(file.name.lastIndexOf("."));
      if (!types.includes(type)) {
        this.$message.info("所选文件格式不符，请重新选择图片");
        return false;
      }
    },
    httpUpload({ file }) {
      this.handleRemoveFile();
      let formData = new FormData();
      formData.append("file", file);
      formData.append("activateType", this.formSet.activateType);
      this.uploadLoading = true;
      importCardKey(formData)
        .then((res) => {
          if (res.code == 1) {
            this.uploadLoading = false;
            this.errorTip = "";
            this.formSet.batchId = res.data.batchId;
            this.formSet.quantityTotal = res.data.total;
            this.fileList = [{ name: file.name, url: res.data.fileUrl }];
            this.$message.success("激活码导入成功");
          } else {
            this.errorTip = res.message;
          }
        })
        .catch((error) => {
          this.errorTip = "模板内容填写错误，请检测后重新导入";
          this.uploadLoading = false;
        });
    },
    handleRemoveFile(file, fileList) {
      this.fileList = [];
      this.formSet.batchId = "";
      this.formSet.quantityTotal = "";
    },
    // 上传成功
    handleUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.formSet.planImg = res.data;
        this.imgList = [
          {
            url: this.formSet.planImg,
            name: this.formSet.planName,
          },
        ];
        this.isHideUpload = true;
        this.$message.success("上传图片成功");
      }
    },
    // 上传成功
    modifyHandleUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.modifyForm.planImg = [
          {
            url: res.data,
            name: "",
          },
        ];
        this.isHideUpload = true;
        this.$message.success("上传图片成功");
      }
    },
    resetUrl() {
      this.formSet.planImg =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/gift_card.png";
      this.imgList = [
        {
          url: this.formSet.planImg,
          name: this.formSet.planName,
        },
      ];
      this.isHideUpload = true;
    },
    modifyResetUrl() {
      this.modifyForm.planImg = [
        {
          url:
            "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/gift_card.png",
          name: "",
        },
      ];
      this.isHideUpload = true;
    },
    handleRemovePic(file) {
      this.formSet.planImg = "";
      this.imgList = [];
      this.isHideUpload = false;
    },
    modifyHandleRemovePic(file) {
      this.modifyForm.planImg = [];
      this.isHideUpload = false;
    },
    dialogFormSet(formSet) {
      this.$refs[formSet].validate(async (valid) => {
        if (valid) {
          const res = await addGiftCard(this.formSet);
          if (res.code == 1) {
            this.dialogFormVisible = false;
            this.$message.success("礼品卡计划创建成功");
            this.$nextTick(() => {
              this.$refs.inputForm.formSearch();
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.topTip {
  display: flex;
  align-items: center;
  position: relative;
  background: #fafafa;
  height: 120px;
  margin: 30px;
  .beans {
    margin: 20px;
  }
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
.pagination {
  margin: 20px;
  text-align: right;
}
.import {
  position: relative;
  display: flex;
  &-tip {
    color: #ff0000;
  }
  &-text {
    margin-top: 8px;
    line-height: 18px;
  }
  &-right {
    position: absolute;
    top: 0;
    left: 95px;
    // margin-left: -103px;
  }
}
.upload {
  display: flex;
  align-items: center;
  /deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 107px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  .planImg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 12px;
    &-tip {
      color: #999999;
      font-size: 12px;
      line-height: 20px;
    }
  }
}
.footer-btn {
  margin-top: 20px;
  text-align: center;
}
.copy {
  display: flex;
  align-items: center;
}
.state {
  padding: 6px 10px;
  border-radius: 17px;
}
.y1 {
  color: #02b1ff;
  background-color: #e6f7ff;
}
.y2 {
  color: #f36f39;
  background: #fef1ec;
}
.y3 {
  color: #5b5b5b;
  background: #f1f1f1;
}
.hide ::v-deep .el-upload--picture-card {
  display: none;
}
</style>
